export default __webpack_public_path__ + "static/media/cover.8c9d5566.jpg";